import React from "react";
import { AiFillMessage, AiOutlineMessage } from "react-icons/ai";
import rocket from "../assets/images/rocket.png";
import { useForm, ValidationError } from "@formspree/react";
import { FiSend, FiMail } from "react-icons/fi";
import { FaHandPeace } from "react-icons/fa";
import Electrical from "../components/animations/Electrical";
import { useRef } from "react";
import { toast } from "react-toastify";
import { useEffect } from "react";
function ContactMe() {
  const [state, handleSubmit] = useForm("mjvdwyyn");
  const formRef = useRef();

  const submitHandler = (e) => {
    handleSubmit(e);
  };
  useEffect(() => {
    if (state.succeeded) {
      formRef.current.reset();
      toast.success("Your message has shared");
      console.log("'sended");
    } else if (state.errors) {
      toast.error(state.errors[0]?.message);
    }
  }, [state.succeeded, state.errors]);

  return (
    <section id="contactMe">
      <div className="section__title">Contact Me</div>
      <div className="container rounded-lg md:py-4 py-8 bg-containerColor dark:bg-darkContainerColor text-textColor dark:text-darkTextColor flex items-center justify-center flex-col md:flex-row">
        <div className="desc w-full flex  items-center justify-center ">
          <div className="flex flex-col justify-center items-center md:items-start  gap-4 md:gap-8">
            <span className="text-center md:text-left text-xl sm:text-2xl md:text-4xl font-semibold tracking-widest leading-6 text-textColor dark:text-white">
              Let's chat. <br /> Tell me about your <br /> project.
            </span>
            <div className="section__contentSubTitle flex gap-2 ">
              Let's create something together
              <FaHandPeace className="text-yellow-400" />
            </div>
            <div className="relative">
              <Electrical className="absolute left-[-20%] top-[-240%]  opacity-40 w-[200%] invisible lg:visible" />
              <div className="relative self-center flex items-center justify-center gap-2 p-4 md:p-8 border-[0.5px] border-leetcodeBorderColor rounded-xl shadow-xl bg-bodyColor dark:bg-darkContainerColor">
                <div className="rounded-lg bg-gray-50 dark:bg-gray-700 p-2 ">
                  <FiMail className="text-2xl" />
                </div>
                <div className="relative">
                  <div className="flex flex-col items-start ">
                    <span>Mail me at</span>
                    <a
                      className="text-firstColor cursor-default lg:cursor-pointer"
                      href="mailto:pranavmappoli@gmail.com"
                      target="_blank"
                    >
                      Pranavmappoli@gmail.com
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="contactMe w-full flex justify-center md:justify-start items-center ">
          <div class=" flex flex-col my-8 lg:my-16  p-4 w-[90%] lg:w-[70%] border-[1px] border-leetcodeBorderColor rounded-xl shadow-xl bg-bodyColor dark:bg-darkContainerColor">
            <div class="self-center md:self-start section__subtitle tracking-wide  text-left mt-4 lg:mt-8 flex gap-2 text-textColor dark:text-darkTextColor ">
              Send me a message
              <img className="w-10 h-10" src={rocket} alt="" />
            </div>
            <p class="mb-8 lg:mb-16 font-light text-center  sm:text-xl"></p>
            <form
              class="space-y-8 flex flex-col"
              onSubmit={submitHandler}
              ref={formRef}
            >
              <div>
                <label for="email" class="block mb-2 text-sm font-medium ">
                  Your email
                </label>
                <input
                  type="email"
                  name="email"
                  id="email"
                  class="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-leetcodeBorderColor block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-leetcodeBorderColor dark:shadow-sm-light"
                  placeholder="name@email.com"
                  required
                />
              </div>
              <div>
                <label for="subject" class="block mb-2 text-sm font-medium ">
                  Subject
                </label>
                <input
                  type="text"
                  name="subject"
                  id="subject"
                  class="block p-3 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 shadow-sm focus:ring-primary-500 focus:border-leetcodeBorderColor dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-leetcodeBorderColor dark:shadow-sm-light"
                  placeholder="Let us know how we can help you"
                  required
                />
              </div>
              <div class="sm:col-span-2">
                <label
                  for="message"
                  class="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-400"
                >
                  Your message
                </label>
                <textarea
                  id="message"
                  name="message"
                  rows="6"
                  class="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg shadow-sm border border-gray-300 focus:ring-primary-500 focus:border-leetcodeBorderColor dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                  placeholder="Leave a comment..."
                ></textarea>
              </div>

              <button
                disabled={state.submitting}
                type="submit"
                className="self-center md:self-start flex justify-center items-center gap-2 py-3 px-8  rounded-xl border-[1px] shadow-md border-leetcodeBorderColor capitalize hover:-translate-y-[2px] transition-transform lg:cursor-pointer "
              >
                Send messagae
                <FiSend className="text-firstColor text-xl" />
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ContactMe;
